(function($){

    // Function to save the scroll position when leaving the page
//     const gtm4wp_is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
//     if (gtm4wp_is_safari) {
//         window.addEventListener('pageshow', function(event) {
//             if (event.persisted) {
//                 // if Safari loads the page from cache usually by navigating with the back button
//                 // it creates issues with product list click tracking
//                 // therefore GTM4WP forces the page reload in this browser
//                 window.location.reload();
//             }
//         });
//     }

    // MINICART INITIAL
     $(document).on("click", ".minicart-dropdown .minicart > a", function(e){
        e.preventDefault();
        if(window.location.pathname == '/cart/' || window.location.pathname == '/checkout/'){
            window.location.href = '/cart/';
            // return;
        }else {

//             console.log($(this))
            if(!$('.minicart-dropdown.active .mega_menu.cart').is(":visible")){
//                 console.log('zzz')
//                 load_minicart();
            }

            var heights = $(".ProductCrossSells_minicart_crossells .product.ProductCrossSells").map(function (){
                return $(this).height();
            }).get();

            maxHeight = Math.max.apply(null, heights);
            $(".ProductCrossSells_minicart_crossells .ProductCrossSells_crossells_inner").css('height', maxHeight);

//              qtyClick();
            var content = $('.ProductCrossSells_minicart_crossells');

            if (!content.hasClass('slick-initialized')) {
                $(content).slick({
                    arrows: false,
                    draggable: true,
                    swipe: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    adaptiveHeight: false,
                    infinite: false,
                    autoplay: false,
                    dots: true,
                    fade: false,
                });
            }
            $('body').addClass('mini-open').removeClass('is-toggled');
            $('html').removeClass('is-toggled');
            $('.JonathangrenMainMenu-mobile_menu_icon').removeClass('open');
    //         $('.mega_menu.cart').toggle();
            $('.minicart-dropdown').addClass('active');
            $('body').addClass('minicart-opened');
            $('.minicart-header .title').css('display','block');
            $('.minicart-header .title.added').css('display','none');
             if( !$('.popup-overlay').length ){
                $('body .minicart-dropdown').append("<div class='popup-overlay'></div>");
            }

            $('.ProductCrossSells_minicart_crossells .ProductCrossSells').each(function(){
                var $checked = $(this).find('input:checked').filter(':first');;
//                 console.log($checked.parent().hasClass('disabled'))
                if($checked.parent().hasClass('disabled')){
                    $checked.parent().parent().parent().find('.custom_add_to_cart_button').addClass('disabled');
                }
            })
            e.stopPropagation();
        }

//         $('.woocommerce-MyAccount-navigation').removeClass('active');
    });
    // $('body').on('click', '.popup-overlay',function (){
    //     alert('cao');
    //     console.log($('body').hasClass('minicart-opened'));
    //     $('body').removeClass('minicart-opened');
    // });
     $( 'html' ).on('click', function(e) {
         // e.stopPropagation();
         if($('body').hasClass('minicart-opened')) {
             $('body').removeClass('minicart-opened');
         }
     });

     $( document ).on('click', '.mega_menu.cart', function(e) {
         e.stopPropagation();
     });

//     JGaddToCartSubmit();
//     function JGaddToCartSubmit(){
     // ON FORM SUBMIT
        $( document ).on('submit', 'form.cart', function(e) {
            e.preventDefault();
            var form = $(this);

            form.block({ message: null, overlayCSS: { background: '#fff', opacity: 0.6 } });
            var formData = new FormData(form[0]);
//             console.log(formData);
//             console.log(form);
            var product_id = form.find('[name=add-to-cart]').val();
            formData.append('add-to-cart', product_id);
            if($('.JG-cart-page').length){

                $('html, body').animate({scrollTop: '0px'}, 300);
                $('.JG-cart-page > .fl-row-content-wrap').css({
                    opacity: 0.4
                });
            }
            console.log($('.product.product-type-grouped').length);
            if ($('body').hasClass('single-product') && $('.product.product-type-grouped').length) {
                const product_link = $('form.cart').attr('action');
                const product_bundle_size = $('input[name="huemor_bundle_size"][data-bundle-id="' + product_id + '"]').val();
                const bundle_data = {
                    'product_id': product_id,
                    'product_link': product_link + `?bundle_size=${product_bundle_size}`,
                    'product_bundle_size': product_bundle_size
                };
                formData.append('bundle-data', JSON.stringify(bundle_data));
            }

            // Ajax action.
            $.ajax({
                url: wc_add_to_cart_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'custom_jg_add_to_cart' ),
                data: formData,
                type: 'POST',
                processData: false,
                contentType: false,
                complete: function( response ) {
                    response = response.responseJSON;
                    if ( ! response ) {
                        return;
                    }
                    if ( response.error && response.product_url ) {
                        window.location = response.product_url;
                        return;
                    }
                    // Redirect to cart option
                    if ( wc_add_to_cart_params.cart_redirect_after_add === 'yes' ) {
                        window.location = wc_add_to_cart_params.cart_url;
                        return;
                    }
                    var $thisbutton = form.find('.single_add_to_cart_button');
    //              var $thisbutton = null; // uncomment this if you don't want the 'View cart' button
                    // Trigger event so themes can refresh other areas.
                    $( document.body ).trigger( 'added_to_cart', [ response.fragments, response.cart_hash, $thisbutton ] );
                    
                    if($('.JG-cart-page').length){
//                         console.log('aaaaa')
//                         $('html, body').animate({scrollTop: '0px'}, 300);
                        $('.JG-cart-page .fl-row-content-wrap').css({
                            opacity: 1
                        })
                    }else {

                        $('.minicart-dropdown').addClass('active');
                        $('.minicart-header .title').css('display','none');
                        $('.minicart-header .title.added').css('display','block');

                        if( !$('.popup-overlay').length ){
                            $('body .minicart-dropdown').append("<div class='popup-overlay'></div>");
                        }
                         // Remove existing notices
                        $( '.woocommerce-error, .woocommerce-message, .woocommerce-info' ).remove();
                    }
                    
                   
                    // Add new notices
                    var content = $('.ProductCrossSells_minicart_crossells');
                    if (!content.hasClass('slick-initialized')) {
                        $(content).slick({
                            arrows: false,
                            draggable: true,
                            swipe: true,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            adaptiveHeight: false,
                            infinite: false,
                            autoplay: false,
                            dots: true,
                            fade: false,
                        });
                    }


    //                 form.closest('.product').before(response.fragments.notices_html)
                    form.unblock();
                }
            });
        });

        // ON ADD TO CART CLICK
        $('body').on( 'added_to_cart', function(){
            //your popup trigger code here;
            if($('.JG-cart-page').length){
                
                $('.JG-cart-page > .fl-row-content-wrap').css({
                    opacity: 0.4
                })
                $('html, body').animate({scrollTop: '0px'}, 300);
            }else {
                $('.minicart-dropdown').addClass('active');
                $('.minicart-header .title').css('display','none');
                $('.minicart-header .title.added').css('display','block');
                if( !$('.popup-overlay').length ){
                    $('body .minicart-dropdown').append("<div class='popup-overlay'></div>");
                }
            }
            

        });
//     }
//     function load_minicart(){
//         console.log($('input[name="attribute_size"]').length);
//         if($('input[name="attribute_size"]').length > 0){

            qtyClick();
            // ON ATTRIBUTE CLICK
            $(document).on('click', 'input[data-name="attribute_size"]', function(){
//                 console.log( $(this).attr('data-price'))
                $(this).closest('.ProductCrossSells-product_right').find('.ProductCrossSells_price').html('$'+$(this).attr('data-price'));
                $(this).parent().parent().parent().find('.ProductCrossSells_attributes input').prop('checked', false);
                 $(this).prop('checked', true);
                var variationId = $(this).val();
                var variationText = $(this).siblings('span').text();
//                 console.log(variationId)
                $(this).closest('.ProductCrossSells_attributes').siblings('.custom_add_to_cart_button').removeClass('disabled')
//                 console.log(variationText)
//                 $(this).closest('.ProductCrossSells_attributes').siblings('.custom_add_to_cart_button').click(function (e) {
// //                      console.log(variationText)
//                     e.preventDefault();
//                      miniCratCrossSellsAddToCart($(this));
// 
// 
// 
//                 });
            })



            $(document).on('click', '.ProductCrossSells_minicart_crossells .custom_add_to_cart_button', function (e) {
                e.preventDefault();
                if(!$(this).hasClass('disabled')){
                    miniCratCrossSellsAddToCart($(this));
                }else {
                    return false;
                }

            });

            function miniCratCrossSellsAddToCart(clicked){
                var variationId = clicked.siblings('.ProductCrossSells_attributes').find('input:checked').val();
                var variationText = clicked.siblings('.ProductCrossSells_attributes').find('input:checked').siblings('span').text();
                 var prId = clicked.parent().parent().parent().attr('data-product-id');
                clicked.closest('.minicart-dropdown.active').find('.mega_menu.cart > .Jonathangren-loader').show();
                clicked.closest('.minicart-dropdown.active').find('.mega_menu.cart > .Jonathangren-overlay').show();
                if(!clicked.siblings('.ProductCrossSells_attributes').find('input:checked').parent().hasClass('disabled')){
                    var data = {
                        action: 'cross_woocommerce_ajax_add_to_cart',
                        product_id: prId,
                        variationID: variationId,
                        variationName: variationText,
                        quantity:  1
                    };
    //                     console.log(data)
                    $.ajax({
                        type: 'post',
                        url: wc_add_to_cart_params.ajax_url,
                        data: data,
                        async: true,

                        success: function (response) {
    //                             console.log('addedddd')
                            $(this).addClass("added");
                            $(document.body).trigger('wc_fragment_refresh');
                            $('.minicart-header .title').css('display','none');
                            $('.minicart-header .title.added').css('display','block');
                            $('.Jonathangren-loader').hide();
                            $('.Jonathangren-overlay').hide();
                        },
                        error: function (xhr, ajaxOptions, thrownError) {
    //                             console.log(xhr.status);
    //                             console.log(ajaxOptions);
                            console.log(thrownError);
                        }
                    });
                }
                
                if (window.dataLayer) {
                    var variation_ga4_data = JSON.parse(clicked[0].dataset.gaAttributeData),
                        variation = variation_ga4_data[variationId];
                    dataLayer.push({ ecommerce: null });
                    dataLayer.push({
                        event: "add_to_cart",
                        ecommerce: {
                            currency: "USD",
                            value: variation["price"],
                            items: [variation]
                        }
                    });
                }

                return;
            }
//         } else {
//             $(document).on('click', '.ProductCrossSells_minicart_crossells .custom_add_to_cart_button.single', function (e) {
            $(document).on('click', '.ProductCrossSells_minicart_crossells .custom_add_to_cart_button.single', function(e){
                e.preventDefault();
                var productID = $(this).attr("data-id");
                $(this).closest('.minicart-dropdown.active').find('.mega_menu.cart > .Jonathangren-loader').show();
                $(this).closest('.minicart-dropdown.active').find('.mega_menu.cart > .Jonathangren-overlay').show();
                $('.mega_menu > .Jonathangren-loader').show();
                update_minicart(1, productID, '', 1);
//                 var data = {
//                     action: 'cross_woocommerce_ajax_add_to_cart',
//                     product_id: productID,
//                     quantity:  1
//                 };
//                 $.ajax({
//                     type: 'post',
//                     url: wc_add_to_cart_params.ajax_url,
//                     data: data,
//                     async: true,
//                     complete: function (response) {
//                        
//                         $(this).addClass("added");
//                         $(document.body).trigger('wc_fragment_refresh');
//                         $('.Jonathangren-loader').hide();
//                         return;
//                     },
//                 });
            })
//         }

//     }
    // UPDATE MINICART FUNCTION
    function update_minicart(qty='', prId='', variationId='', numberBox = 0){
        if(qty >= 1){
            var data = {
                action: 'cross_woocommerce_ajax_add_to_cart',
                product_id: prId,
                variationID: variationId,
                numberBox: numberBox,
                quantity:  qty
            };
            $.ajax({
                type: 'post',
                url: wc_add_to_cart_params.ajax_url,
                data: data,
                async: true,
                complete: function (response) {
                    $(this).addClass("added");
                    $(document.body).trigger('wc_fragment_refresh');
                    $('.minicart-header .title').css('display','none');
                    $('.minicart-header .title.added').css('display','block');
                    $('.Jonathangren-loader').hide();
                    $('.Jonathangren-overlay').hide();

                    return;
                },
            });
        }
    }
    // QTY FUNCTION 
    function qtyClick(){
        $(document).on('click', '.number-box .clickable', function(){
            var prodId = $(this).parent().attr('data-id');
            var VariationId = $(this).parent().attr('data-variationid');
            var qty = parseInt($(this).siblings('.qty').text());
            var qtyMax = parseInt($(this).siblings('.qty').attr('max'));
            console.log(qtyMax)

            if($(this).attr('data-val') == 'plus'){
                qty = qty + 1;
            }else {
                if (qty > 1){
                    qty = qty - 1;
                } else {
                    qty = 1;
                }

            }

//             console.log(qty)
             $(this).closest('.minicart-dropdown.active').find('.mega_menu.cart > .Jonathangren-loader').show();
            $(this).closest('.minicart-dropdown.active').find('.mega_menu.cart > .Jonathangren-overlay').show();
            update_minicart(qty, prodId, VariationId, 0);

        })
    }

//     if($('#order_review').length){
//         $(document).on('click', '.plus', function (e) {
//             e.preventDefault();
//             e.stopPropagation();
//             if($(this).siblings('input').val() < 100){
//                 $(this).siblings('input').val(+$(this).siblings('input').val() + 1).trigger( "change" );
//             }
//             if($(this).prev().val() < 100){
//                 $(this).prev().val(+$(this).prev().val() + 1);
//                 if($('#order_review').length){
//                     $(this).prev().trigger( "change" );
//                 }
//             }
//         });
// 
//         $(document).on('click', '.minus', function (e) {
//             e.preventDefault();
//             e.stopPropagation();
//             if($(this).siblings('input').val() > 1){
//                 $(this).siblings('input').val(+$(this).siblings('input').val()-1).trigger( "change" );
//             }
//         });
//     }


    // CROSS-SELS SLIDER AFTER MINICART AJAX COMPLETE
     $( document ).ajaxComplete(function() {

        if($('.mega_menu.cart').length){
            var content = $('.ProductCrossSells_minicart_crossells');

            if (!content.hasClass('slick-initialized')) {
                $(content).slick({
                    arrows: false,
                    draggable: true,
                    swipe: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    adaptiveHeight: false,
                    infinite: false,
                    autoplay: false,
                    dots: true,
                    fade: false,
                });
            }
            $('.ProductCrossSells_minicart_crossells .ProductCrossSells').each(function(){
                var $checked = $(this).find('input:checked').filter(':first');;
//                 console.log($checked.parent().hasClass('disabled'))
                if($checked.parent().hasClass('disabled')){
                    $checked.parent().parent().parent().find('.custom_add_to_cart_button').addClass('disabled');
                }
            })

            if($('.ProductCrossSells_minicart_crossells .ProductCrossSells.slick-slide').length == 0){
                $('p.ProductCrossSells_minicart_info').hide();
            }else {
                $('p.ProductCrossSells_minicart_info').show();
            }
        }

    });

     // CLOSING MINICART
    $('.minicart-dropdown span.close').click(function (e) {
        e.preventDefault();
        $('.minicart-dropdown').removeClass('active');
        $('.minicart-header .title').css('display','block');
        $('.minicart-header .title.added').css('display','none');
        $('body .popup-overlay').remove();
        $('body').removeClass('minicart-opened');
//         $('body').removeClass('mini-open');
    });

    // CLOSING LOGIN FORM
    $(document).on('click','.woocommerce-form-login.login .close-form', function (e) {
        e.preventDefault();
        $(this).parent().hide();
    });

    // TOGGLE SEARCH BUTTON
    var el = document.getElementById('SearchInputToFocus');
    $(document).on('click', '.JonathangrenMainMenu-search_button > a > span.magic-icon-search.toOpen', function(e){
        e.preventDefault();

        if(!$(this).hasClass('close')){
            $('.JonathangrenMainMenu-mobile_menu_icon').removeClass('open is-active')
            $('html').removeClass('is-toggled')
            $('body').removeClass('is-toggled')
             $(this).addClass('close').removeClass('toOpen');
    //         $(this).closest('.JonathangrenMainMenu-main_full_wrapper').toggleClass('activeHover');
            $(this).closest('.JonathangrenMainMenu-main_full_wrapper').addClass('activeSearchHover');

            // var el = $("#SearchInputToFocus");
            $(".JonathangrenMainMenu-search_form").slideDown().addClass('active');
            $(".JonathangrenMainMenu-search_form input[type='search']").focus();
            el.readOnly = false;
            el.focus();
            el.click();
            // el.value = el.value;

        }
    })
    $(document).on('click', '.JonathangrenMainMenu-search_button > a > span.magic-icon-search.close', function(e){
        e.preventDefault();
        $(this).removeClass('close').addClass('toOpen');
        $(this).closest('.JonathangrenMainMenu-main_full_wrapper').removeClass('activeSearchHover');
        $(".JonathangrenMainMenu-search_form").hide().removeClass('active');
    })

        $('.JonathangrenMainMenu-mobile_menu_icon').click(function(){
            $(this).toggleClass('open');
        });


    // Product Single quantity change on  click
     if($('.quantity').length || $('.JonathangreenLawnCareQuiz-wrapper').length){
        $(document).on('click', '.plus', function(){
            if($(this).prev().val() <= 20){
                $(this).prev().val(+$(this).prev().val() + 1);
                if($('#order_review').length){
                    $(this).prev().trigger( "change" );
                } else {
                    $(this).parent('.quantity').find('input.qty').trigger( "change" );
                }
            }else {
                var field = $(this).prev();
                field[0].reportValidity()
                field[0].setCustomValidity("Value must be less than or equal to 20 ")
            }

            var newQTY = $('.quantity input').val();

            $('.woocommerce .JG-sticky-add-to-cart .quantity').find('input').val(newQTY)
        });

        $(document).on('click', '.minus', function(){
            if($(this).next().next().val() > 1){
                $(this).next().next().val(+$(this).next().next().val()-1);
                if($('#order_review').length){
                    $(this).next().next().trigger( "change" );
                } else {
                    $(this).parent('.quantity').find('input.qty').trigger( "change" );
                }
            }
            var newQTY = $('.quantity input').val();
            $('.woocommerce .JG-sticky-add-to-cart .quantity').find('input').val(newQTY)
        });
    }

    // SPECIFICATION 
    if($('.JonathangreenSpecifications').length){
//         console.log('ssssss')
        $('.JonathangreenSpecifications li h4').each(function(){

            $(this).click(function(){

                $(this).toggleClass('active');
                $(this).parent().siblings().find('h4').removeClass('active');
                $(this).siblings('.JonathangreenSpecifications_content').slideToggle();
                $(this).parent().siblings().find('.JonathangreenSpecifications_content').slideUp();

                $(this).closest('ul.JonathangreenSpecifications').siblings().find('h4').removeClass('active');
                $(this).closest('ul.JonathangreenSpecifications').siblings().find('.JonathangreenSpecifications_content').slideUp();
            });
        });
    }

    // sticky add to cart
    if($('.JG-sticky-add-to-cart').length){

        var $button = $('.JG-sticky-add-to-cart').find('form.variations_form .single_add_to_cart_button');
        if($button.hasClass('disabled')){
            $button.html('Sold out')
        }else {
            $button.html('Add to cart')
        }

        if($(".JonathanGreen-product-information .variations_form").length){
            var offsetTop = $(".JonathanGreen-product-information .variations_form").offset().top + 180;
        }else {
            var offsetTop = $(".JonathanGreen-product-information form.cart").offset().top + 180;
        }
        if($('.jg-product-info-wrapper .variations select').length < 2){
            var selectedVariation = $('.jg-product-info-wrapper .variations select').find("option:selected").text();
//     console.log($('.jg-product-info-wrapper .variations select').length)
            if(selectedVariation){
                $('.JG-sticky-add-to-cart_title h5 span').text(selectedVariation);
            }
        }
        
        
        $(window).on('scroll', function () {
            stickyAddToCart();
        });

        function stickyAddToCart(){
            var scrollTop = $(window).scrollTop();
            if(scrollTop > offsetTop){
                $(".JG-sticky-add-to-cart").css('bottom', 0);
            }else {
                $(".JG-sticky-add-to-cart").css('bottom', '-90px');
            }
        }
    }

     $(window).on('load resize', function(){
         var ImageWrapperWidth = 600;
        if($(window).width() >= 1024 && $(window).width() < 1200){
            ImageWrapperWidth = $('.woocommerce div.product div.images.woocommerce-product-gallery').width() - 100;
        } else if ( $(window).width() < 1024 ) {
//             console.log('sss')
             ImageWrapperWidth = $('.woocommerce div.product div.images.woocommerce-product-gallery').width();
        } else {
            ImageWrapperWidth
        }

        $('.woocommerce div.product div.images.woocommerce-product-gallery .woocommerce-product-gallery__image a').css('width', ImageWrapperWidth);
        
        if($(window).width() < 769){
            $('.woocommerce-account.logged-in .woocommerce-MyAccount-content table.shop_table tbody td').each(function(){
                var dataAttr = $(this).attr('data-title');
                if(dataAttr !== undefined){
                    dataAttr = dataAttr.replace(/\?/g, '');
                    if(!$(this).find('.JG_table_before').length){
                        $(this).prepend("<span class='JG_table_before'>"+dataAttr+"</span>");
                    }
                }
            })
        }

     })


    // PRODUCT GALLERY THUMBNAILS - IF WE HAVE MORE THAN 6
    if($('.woocommerce-product-gallery').length){
        $(window).on('load', function(){
            if($('ol.flex-control-thumbs li').length > 6 && $(window).width() >= 1024 ){
                $('ol.flex-control-thumbs li:nth-child(6)').addClass('last-thumb-img');
                var imageLeft = $('ol.flex-control-thumbs li').length - 6;

                $('ol.flex-control-thumbs li:nth-child(6)').addClass('last-thumb-img').append("<span class='JG-thumbnail-overlay'>+ "+imageLeft+' more</span>');
                $('.woocommerce-product-gallery ol.flex-control-thumbs li.last-thumb-img .JG-thumbnail-overlay').on('click', function(){

                    jQuery('.woocommerce-product-gallery').flexslider(5);
                    $(this).parent().parent().parent().find('.woocommerce-product-gallery__trigger').trigger('click');
                })
            }

        });
    }

    $(document).mouseup(function(e)
    {
        var container = $(".popup-overlay");
        
        var searchContainer = $(".JonathangrenMainMenu-search_form.active");
        var searchButton = $('.magic-icon-search')

        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0)
        { } else {
            $('.minicart-dropdown').removeClass('active');
            $('body').removeClass('minicart-opened');
            $('.minicart-header .title').css('display','block');
            $('.minicart-header .title.added').css('display','none');
            container.remove();
        }
        
        if (!searchContainer.is(e.target) && searchContainer.has(e.target).length === 0) { 

            if(!searchButton.is(e.target)){
                searchContainer.hide();
            $('.magic-icon-search').removeClass('close').addClass('toOpen');  
            $('.JonathangrenMainMenu-light').removeClass('activeSearchHover')
            }
            
        }
    });

    $("form.checkout.woocommerce-checkout").keypress(function(e) {
        //Enter key
        if (e.which == 13) {
            return false;
        }
    });

    if($('.enter_promo_code').length){
        $(document).on('click', '.enter_promo_code', function(){
            $(this).toggleClass('active');
            $(this).parent().find('.coupon').slideToggle();
        })
    }

    // acount navigation for mobile
    if($(window).width() < 768){

        var myaccountNav = $('.woocommerce-MyAccount-navigation');
        $(".woocommerce-MyAccount-navigation-link--dashboard").append('<span class="dropMe"></span>');
        $(".woocommerce-MyAccount-navigation-link--dashboard .dropMe").click(function() {
            /*  Toggle the CSS closed class which reduces the height of the UL thus
                hiding all LI apart from the first */
            var myaccountNavHeight = $('.woocommerce-MyAccount-navigation ul').height();
            $(this).parent().toggleClass('active');
            $(this).parent().parent().parent().toggleClass("open");
            if (myaccountNav.hasClass('open')){
                myaccountNav.css("height", myaccountNavHeight);
            }else{
                myaccountNav.css("height", '');
            }
        });
        
        $('.woocommerce-MyAccount-navigation ul li a').on('click', function() {
            myaccountNav.removeClass('open').css("height", '');
        })
    }

    if($('.woocommerce-checkout .coupon-form').length){
//         $( document ).on( "ajaxComplete", function() {
            $( document.body ).on( 'click', 'a.showcoupon', function(e){
                if ($(this).hasClass('active')) {
                    console.log('matched');
                    $(this).removeClass('active');
                } else {
                    console.log('wrong class');
                    $(this).addClass('active');
                }
//                 if( $("a.showcoupon").hasClass('active') ){
//                      $("a.showcoupon").removeClass('active');
//                 }else {
//                     $(this).addClass('active');
//                 }
//                 $("a.showcoupon").removeClass("active");
               
            });
//         } );
        
    }
    
//     $('a[href*=".jpg"], a[href*=".jpeg"], a[href*=".png"], a[href*=".gif"]').fancybox({
//         selector : '.woocommerce-product-gallery ol li:nth-child(6) img'
//     });

    function formVariationLoad(product){
        // product.querySelector('table.variations select').each(function() {
        var $this = jQuery(product.querySelector('table.variations select')),
            numberOfOptions = $this.children('option').length,
            form = product.querySelector('form.cart');

            if(!$this.closest('.fl-module-fl-woo-cart-button').length){

                var html = "";
//                             html += "<div class='JG-out-of-stock'> sold out </div>";

                if(!$this.parent('.JG-select').length){
                    $this.addClass('JG-select-hidden');
                    $this.wrap('<div class="JG-select"></div>');
                    if( numberOfOptions == 2){
                        $this.after('<div class="JG-select-styled-no-drop"></div>');
                    } else {
                        $this.after('<div class="JG-select-styled"></div>');
                    }
                }

                var $styledSelect = $this.next('div.JG-select-styled');
                $styledSelect.text($this.children('option:selected').text());

                var $styledSelectNoDrop = $this.next('div.JG-select-styled-no-drop');
                $styledSelectNoDrop.text($this.children('option:selected').text());


                if($this.parent().find('.JG-select-options').length){
                    return;
                } else {

                    var $list = jQuery('<ul />', {
                        'class': 'JG-select-options'
                    }).insertAfter($styledSelect);
                    // console.log(numberOfOptions)
                    for (var i = 0; i < numberOfOptions; i++) {
                        if($this.children('option').eq(i).val() != ''){
                            jQuery('<li />', {
                                text: $this.children('option').eq(i).text(),
                                rel: $this.children('option').eq(i).val()
                            }).appendTo($list);
                        }else {
                            jQuery('<li />', {
                                text: $this.children('option').eq(i).text(),
                                rel: 'first'
                            }).appendTo($list);
                        }

                    }

                    var $listItems = $list.children('li');

                    $styledSelect.click(function(e) {
                        e.stopPropagation();
                        jQuery('div.JG-select-styled.active').not(jQuery(this)).each(function() {
                            jQuery(this).removeClass('active').next('ul.JG-select-options').hide();
                        });
                        if (jQuery(this).hasClass("active")) {
                            jQuery(this).removeClass('active').next('ul.JG-select-options').hide();
//                                     console.log('hide')
                        } else {
                            jQuery(this).addClass('active').next('ul.JG-select-options').show();
//                                     console.log('show')
                        }
                        //                             jQuery(this).toggleClass('active').next('ul.JG-select-options').toggle();
                    });

                    $listItems.click(function(e) {
                        e.stopPropagation();
                        $styledSelect.text(jQuery(this).text()).removeClass('active');

                        $this.val(jQuery(this).attr('rel'));
                        $list.hide();
                        $this.trigger( 'change' );
                        var $button = $this.closest('form.variations_form').find('.single_add_to_cart_button');
                        if($button.hasClass('disabled')){
                            $button.html('Sold out')
                        }else {
                            $button.html('Add to cart')
                        }

                    });

                    jQuery(document).click(function() {
                        $styledSelect.removeClass('active');
                        $list.hide();
                    });
                }

            jQuery(form).wc_variation_form();
            }
        // });
    }

    // Using fetch API for AJAX request
    function apiRequest(action, data, product, method = 'POST') {
        return new Promise((resolve, reject) => {
            if (!action || typeof bw_js_vars.products_nonce === "undefined") {
                reject(new Error('Action is required'));
                return;
            }
            const formData = new FormData();

            formData.append('action', action);
            formData.append('nonce', bw_js_vars.products_nonce);
            formData.append('data', data);

            fetch(window.wpAjaxUrl, {
                method: method,
                body: formData
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json();
                })
                .then(data => {
                    if (!product.querySelector('form.cart')) {
                        $(product).append(data.data);
                        formVariationLoad(product);
                    }

                    $(product).find('.Jonathangren-loader-product').remove();

                    resolve(); // Resolve promise

                })

                .catch(error => {
                    console.error('Error:', error);
                    reject(error); // Reject the promise with the error
                });
        });
    }


    window.loadVariations = function loadVariations() {
        let requests = []; // Array to hold promises from apiRequest calls
        const is_home = $('body').hasClass('home');
        if(is_home) {
            return;
        }

        const selectors = [
            'section.JonathangrenCrossSell-wrapper:not(.JonathangrenCrossSell-tabbed-wrapper) ul li.product:not(.product-type-simple):not(.product-type-grouped)',
            '.JonathanGreenSiteSearch-Category_articles.woocommerce li.product:not(.product-type-simple):not(.product-type-grouped)'
        ];

        selectors.forEach(selector => {
            let products = $(selector);
            if (products.length) {
                products.each(function (index, product) {
                    if (product.querySelector('form.cart')) {
                        return;
                    }
                    const productButton = $(product).find('a.button');
                    const productId = productButton.data('product_id');

                    // Assuming apiRequest returns a Promise
                    requests.push(apiRequest('bw_load_variations', productId, product));
                });
            }
        });

        // Use Promise.al or Promise.allSettled to wait for all requests to complete
        Promise.allSettled(requests).then(results => {
        }).catch(error => {
            console.error("Error in requests", error);
        });
    }

    window.loadShopProducts = async function(section_number = 0) {
        // Shop/Category Loops
        let products = $(`.JonathangrenProductFilters-loop-list[data-initial-page="${section_number}"] li.product:not(.product-type-simple):not(.product-type-grouped)`);
        if(!products.length) {
            return;
        }
        for (let product of products) {
            const productButton = $(product).find('a.button');
            const productId = productButton.data('product_id');

            if (product.querySelector('.single_pr_price')) {
                continue;
            }

            // formVariationLoad(product);
            try {
                // Assuming apiRequest returns a Promise and is an async operation
                await apiRequest('bw_load_variations', productId, product);
            } catch (error) {
                console.error("Error in request for product ID " + productId, error);
            }
        }
    };

    $(document).ready(function () {
        window.loadShopProducts();
        window.loadVariations();

        if($('body').hasClass('woocommerce-checkout')) {
            const rememberMeCheckbox = document.getElementById('rememberme');
            if(rememberMeCheckbox) {
                rememberMeCheckbox.checked = true;
            }
        }
    });
})(jQuery);
